module.exports = __webpack_public_path__ + "img/phone-bg.1652c211.png";